import React, { useEffect } from 'react';
import { checkIfScroll } from '../helpers';
import DynamicIcon from './Icons/DynamicIcon';
import HotspotIcon from './Icons/HotspotIcon';

const IconItemRoom = (props) => {
  const {
    icon,
    position,
    mobilePosition,
    index,
    nameIcon,
    yearIcon,
    triggerFocusOnIcon,
    openDetail,
    type,
    data,
    isMobile,
  } = props;

  useEffect(() => {
    const setPositionForIcon = (index) => {
      if (typeof document !== `undefined`) {
        const iconContainer = document.getElementById(`icon${index}`);
        iconContainer.style.top = position.top;
        iconContainer.style.left = position.left;

        const mobileHotspot = document.getElementById(`mobileIcon${index}`);
        mobileHotspot.style.top = mobilePosition.top;
        mobileHotspot.style.left = mobilePosition.left;
      }
    };

    setPositionForIcon(index);
    checkIfScroll(index, isMobile);
  }, [
    nameIcon,
    index,
    isMobile,
    position.left,
    position.top,
    mobilePosition.top,
    mobilePosition.left,
  ]);

  const triggerZoomIcon = (index) => {
    const zoomedIconConfig = {
      index,
      icon,
      nameIcon,
      yearIcon,
      openDetail,
      type,
      data,
    };
    triggerFocusOnIcon(zoomedIconConfig);
  };

  const commonProps = {
    index,
    icon,
    type,
    data,
  };
  return (
    <>
      <DynamicIcon
        nameIcon={nameIcon}
        yearIcon={yearIcon}
        openDetail={openDetail}
        {...commonProps}
      />
      <HotspotIcon
        index={index}
        triggerZoomIcon={triggerZoomIcon}
        openDetail={openDetail}
      />
    </>
  );
};

export default IconItemRoom;
